/**
 * currentBrand
 * Get environment value containing the name of the current brand
 * @returns {String}
 *
 * is{Brand}Brand
 * Checks if environment value for brand is same as currentBrand
 * Note: These checks do not support Webpack tree shaking.
 * If you want to use it, create local checks, e.g. process.env.BRAND_PREFIX === 'northstar'
 * @returns {Boolean}
 */
const brands = ['hm', 'arket', 'cos', 'monki', 'northstar', 'otherStories', 'weekday'];
export const currentBrand = brands.includes(process.env.BRAND_PREFIX || process.env.BRAND)
    ? process.env.BRAND_PREFIX || process.env.BRAND
    : 'hm';
export const isHmBrand = currentBrand === 'hm';
export const isArketBrand = currentBrand === 'arket';
export const isCosBrand = currentBrand === 'cos';
export const isMonkiBrand = currentBrand === 'monki';
export const isNorthstarBrand = currentBrand === 'northstar';
export const isOtherStoriesBrand = currentBrand === 'otherStories';
export const isWeekdayBrand = currentBrand === 'weekday';
//# sourceMappingURL=brandConfig.js.map